import { render, staticRenderFns } from "./OrderRequestsStatisticsView.vue?vue&type=template&id=b6804330"
import script from "./OrderRequestsStatisticsView.vue?vue&type=script&lang=js"
export * from "./OrderRequestsStatisticsView.vue?vue&type=script&lang=js"
import style0 from "./OrderRequestsStatisticsView.vue?vue&type=style&index=0&id=b6804330&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports